import {CodeViewHeader} from '@github-ui/code-view-header'
import {isReactCodeViewHeaderEnabled} from '@github-ui/code-view-header/is-enabled'
import type {HeaderResponse} from '@github-ui/code-view-header/types'
import {CodeViewBannersProvider} from '@github-ui/code-view-shared/contexts/CodeViewBannersContext'
import type {DataRouterFileOverviewPayload} from '@github-ui/code-view-types'
import {useMemo} from 'react'

import {HeaderBanners} from '../CodeViewBanners'
import {extractOverviewFilesData} from './OverviewSidebar'

export interface MergedHeaderPayload {
  aboutData: HeaderResponse | undefined
  queryKey: readonly unknown[]
}

export interface OverviewHeaderProps {
  overview: Pick<DataRouterFileOverviewPayload['overview'], 'overviewFiles' | 'codeButton'>
  headerData: MergedHeaderPayload
}

export function OverviewHeader({overview, headerData}: OverviewHeaderProps) {
  const overviewFiles = useMemo(() => extractOverviewFilesData(overview), [overview])
  const reactHeaderEnabled = isReactCodeViewHeaderEnabled()
  const {aboutData} = headerData

  if (!aboutData || !reactHeaderEnabled) {
    return null
  }

  return (
    <CodeViewBannersProvider>
      <HeaderBanners />
      <CodeViewHeader
        {...aboutData}
        {...(overviewFiles ?? {})}
        hasAccessToCodespaces={overview.codeButton?.hasAccessToCodespaces ?? false}
      />
    </CodeViewBannersProvider>
  )
}
